import { itemUnit } from "@/models/equip-api-response-objects/itemUnit";
import { Get } from "./utilities-api";

export function GetCalculatedFinbox(
  boxName: string,
  companyGroup: string,
  asOf: string | undefined,
  datacontext: string | undefined
): Promise<financialMetricsSummaryResponse> {
  return Get<financialMetricsSummaryResponse>("/finbox/calculated", {
    boxName: boxName,
    companyGroup: companyGroup,
    asOf: asOf,
    datacontext: datacontext,
  });
}

export interface financialMetricsSummaryResponse {
  name: string;
  title: string;
  lineItems: lineItem[];
}

export interface lineItem {
  formula: string;
  title: string;
  itemUnit: itemUnit;
  currency: string;
  periodValues: periodValue[];
}

export interface periodValue {
  period: string;
  value: string;
}
